// adding must contain a number validation

const rule = {
	name: 'containsAtLeastOneDigit',
	method: (value, element, params) => /[0-9]/.test(value),
	errorMessage: (params, element) => 'Your password must contain at least one digit'
};

export default rule;
